module.exports = __webpack_public_path__ + "static/media/Carp.metal.fe2ad092.png";